import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AuditoriumComponent } from 'src/app/view/infra/auditorium/auditorium.component';
import { BuildingComponent } from 'src/app/view/infra/building/building.component';
import { GymComponent } from 'src/app/view/infra/gym/gym.component';
import { IndoorGameRoomComponent } from 'src/app/view/infra/indoor-game-room/indoor-game-room.component';
import { InfraComponent } from 'src/app/view/infra/infra.component';
import { BiologyComponent } from 'src/app/view/infra/labs/biology/biology.component';
import { ChemistryComponent } from 'src/app/view/infra/labs/chemistry/chemistry.component';
import { ComputerComponent } from 'src/app/view/infra/labs/computer/computer.component';
import { LabsComponent } from 'src/app/view/infra/labs/labs.component';
import { LanguageComponent } from 'src/app/view/infra/labs/language/language.component';
import { MathComponent } from 'src/app/view/infra/labs/math/math.component';
import { PhysicsComponent } from 'src/app/view/infra/labs/physics/physics.component';
import { PlaygroundsComponent } from 'src/app/view/infra/playgrounds/playgrounds.component';
import { ArtComponent } from 'src/app/view/infra/studio/art/art.component';
import { DanceComponent } from 'src/app/view/infra/studio/dance/dance.component';
import { MusicComponent } from 'src/app/view/infra/studio/music/music.component';
import { StudioComponent } from 'src/app/view/infra/studio/studio.component';
import { YogaRoomComponent } from 'src/app/view/infra/yoga-room/yoga-room.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    InfraComponent,
    BuildingComponent,
    LabsComponent,
    PhysicsComponent,
    ChemistryComponent,
    BiologyComponent,
    ComputerComponent,
    MathComponent,
    LanguageComponent,
    StudioComponent,
    ArtComponent,
    MusicComponent,
    DanceComponent,
    GymComponent,
    YogaRoomComponent,
    IndoorGameRoomComponent,
    PlaygroundsComponent,
    AuditoriumComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:InfraComponent,children: [
        {path:'building',component:BuildingComponent},
        {path:'labs',component:LabsComponent,children: [
          {path:'physics',component:PhysicsComponent},
          {path:'chemistry',component:ChemistryComponent},
          {path:'biology',component:BiologyComponent},
          {path:'computer',component:ComputerComponent},
          {path:'math',component:MathComponent},
          {path:'language',component:LanguageComponent},
        ]},
        {path:'studio',component:StudioComponent,children: [
          {path:'art',component:ArtComponent},
          {path:'music',component:MusicComponent},
          {path:'dance',component:DanceComponent},
        ]},
        {path:'gymnasium',component:GymComponent},
        {path:'yoga-room',component:YogaRoomComponent},
        {path:'indoor-game-room',component:IndoorGameRoomComponent},
        {path:'playgrounds',component:PlaygroundsComponent},
        {path:'auditorium',component:AuditoriumComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class InfraModule { }
